import { lazy } from 'react';
import { SHOW_SEARCH_V2 } from '../menu';

const Home = lazy(() => import('./home'));
const Profile = lazy(() => import('./auth/Profile'));
const Orders = lazy(() => import('./orders'));
// import Revenue from './reports/Revenue';
// import Service from './reports/Service';
const MenuManager = lazy(() => import('./menu-manager'));
const Services = lazy(() => import('./services'));
const ServiceSessions = lazy(() => import('./service-sessions'));
const Instructors = lazy(() => import('./instructors'));
const SellerAboutScore = lazy(() => import('./seller-about-score'));
const ProviderVerification = lazy(() => import('./provider-verification'));
const ProReferral = lazy(() => import('./pro-referral'));
const ServiceCreateLogs = lazy(() => import('./services/ServiceCreateLogs'));
const Clinics = lazy(() => import('./clinics'));
const Amenities = lazy(() => import('./amenities'));
const Categories = lazy(() => import('./categories'));
const Countries = lazy(() => import('./countries'));
const Languages = lazy(() => import('./languages'));
const AppointmentRequests = lazy(() => import('./appointment-requests'));
const LongevityConsults = lazy(() => import('./longevity-consults'));
const Currencies = lazy(() => import('./currencies'));
const Posts = lazy(() => import('./posts'));
const Sites = lazy(() => import('./sites'));
const Users = lazy(() => import('./users'));
const UserDetailPage = lazy(() => import('./users/UserDetailPage'));
const Admin2FA = lazy(() => import('./admin-2fa'));
const DirectMessages = lazy(() => import('./direct-messages'));
// import DirectMessages from './direct-messages';
const Widgets = lazy(() => import('./widgets'));
const Faq = lazy(() => import('./faq'));
const CabinRates = lazy(() => import('./cabin-rates'));
// import CreateOrder from './orders/create';
// import Passengers from './orders/Passengers';
// import AddonsOrder from './orders/AddonsOrder';
// import BookingCalendar from './orders/BookingCalendar';
const CabinsOrder = lazy(() => import('./reports/CabinsOrder'));
const Sale = lazy(() => import('./reports/Sale'));
const Roles = lazy(() => import('./roles'));
// import OrderSeats from './orders/order-seats';
const OrderDetails = lazy(() => import('./orders/details/OrderDetails'));
const BookingStatistics = lazy(() => import('./orders/booking-statistics'));
const Invoice = lazy(() => import('./invoice'));
const Dept = lazy(() => import('./reports/Debt'));
// import Options from './options';
const Rates = lazy(() => import('./rates'));
const Reviews = lazy(() => import('./reviews'));
const Templates = lazy(() => import('./templates'));
const App = lazy(() => import('./app-all'));
const SellerPage = lazy(() => import('./seller'));
const SellerDetailPage = lazy(() => import('./seller/SellerDetailPage'));
const SellerContentPage = lazy(() => import('./seller/SellerContentPage'));
const OrganizationPage = lazy(() => import('./organization'));
const LandingPage = lazy(() => import('./landing-page'));
const Affcampaign = lazy(() => import('./affcampaign'));
const CampaignUser = lazy(() => import('./campaign-user'));
const Conversion = lazy(() => import('./conversion'));
const Click = lazy(() => import('./click'));
const Chat = lazy(() => import('./chat'));
const AuditLogsChat = lazy(() => import('./chat/AuditLogsChat'));
const Notifications = lazy(() => import('./notifications'));
const Products = lazy(() => import('./products'));
const Professions = lazy(() => import('./profession'));
const Experts = lazy(() => import('./experts'));
const Interests = lazy(() => import('./interest'));
const Requests = lazy(() => import('./requests'));
const RequestsPendingApproval = lazy(() => import('./requests-pending-approval'));
const PublicOffers = lazy(() => import('./public-offers'));
const Subscriptions = lazy(() => import('./subscriptions'));
const SubscriptionPlans = lazy(() => import('./subscription-plans'));
const Subscribers = lazy(() => import('./subscribers'));
const Offers = lazy(() => import('./offers'));
const Brands = lazy(() => import('./brands'));
const ProductOrders = lazy(() => import('./orders/products'));
const UserRevenue = lazy(() => import('./user-revenue'));
const SystemLog = lazy(() => import('./system-log'));
const EventLog = lazy(() => import('./event-log'));
const AppSettings = lazy(() => import('./app-settings'));
const ColdStartSettings = lazy(() => import('./cold-start-settings'));
const ColdStartActivity = lazy(() => import('./cold-start-activity'));
const CreditOverview = lazy(() => import('./credit-overview'));
const CreditConfig = lazy(() => import('./credit-config'));
const CreditPackages = lazy(() => import('./credit-packages'));
const CreditAdjust = lazy(() => import('./credit-adjust'));
const TrackingPages = lazy(() => import('./tracking-pages'));
const WhatsAppMessages = lazy(() => import('./whatsapp-messages'));
// import CreditWallet from './credit-wallet'; // merged into Credit Transactions (balances shown when filtering by a user)
const CreditTransactions = lazy(() => import('./credit-transactions'));
const CreditPurchases = lazy(() => import('./credit-purchases'));
const VoiceDownloads = lazy(() => import('./voice-downloads'));
const CreatorEarnings = lazy(() => import('./creator-earnings'));
const CreatorPayouts = lazy(() => import('./creator-payouts'));
const Withdrawals = lazy(() => import('./withdrawal'));
const FileManager = lazy(() => import('./file-manager'));
const RoleMenu = lazy(() => import('./role-menu'));
const UserMenu = lazy(() => import('./user-menu'));
const NotificationChannels = lazy(() => import('./notification-channels'));
const NotificationAll = lazy(() => import('./notification-all'));
const NotificationConfig = lazy(() => import('./notification-config'));
const Programs = lazy(() => import('./programs'));
const Wallets = lazy(() => import('./wallets'));
const ServiceSamples = lazy(() => import('./service-sample'));
const HealthSolutions = lazy(() => import('./health-solution'));
const LibraryCategories = lazy(() => import('./library-category'));
const Reports = lazy(() => import('./reports'));
const HealthCheck = lazy(() => import('./health-check'));
const VoicePosts = lazy(() => import('./voice-posts'));
const VoiceBoost = lazy(() => import('./voice-boost'));
const VoiceTrending = lazy(() => import('./voice-trending'));
const VoicePostsAnalytics = lazy(() => import('./voice-posts-analytics'));
const VoicePostsNoSpeech = lazy(() => import('./voice-posts-no-speech'));
const VoiceHashtags = lazy(() => import('./voice-hashtags'));
const VoiceViewReport = lazy(() => import('./voice-view-report'));
const VoiceDurationReport = lazy(() => import('./voice-duration-report'));
const VoiceViewLog = lazy(() => import('./voice-view-log'));
const FeedSimulator = lazy(() => import('./feed-simulator'));
const VoiceHomeWidgets = lazy(() => import('./voice-home-widgets'));
const UserFollows = lazy(() => import('./user-follows'));
const FakeCommentTemplates = lazy(() => import('./fake-comment-templates'));
const FinanceDashboard = lazy(() => import('./finance-home'));
const Vouchers = lazy(() => import('./voucher'));
const ChatBot = lazy(() => import('./chat-bot'));
const LdpInquiries = lazy(() => import('./ldp-inquiries'));
const LdpInquirySendEmails = lazy(() => import('./ldp-inquiry-send-emails'));
const AffiliateTier = lazy(() => import('./affiliate-tier'));
const AffiliateTierHistory = lazy(() => import('./affiliate-tier-history'));
const AffiliateTierUsers = lazy(() => import('./affiliate-tier-users'));
const OrganizationApplication = lazy(() => import('./organization-application'));
const SeedBuyer = lazy(() => import('./seed-buyer'));
const RequestSeed = lazy(() => import('./request-seed'));
const RequestImage = lazy(() => import('./request-image'));
const ServiceRefine = lazy(() => import('./service-refine'));
const SearchIndex = lazy(() => import('./search-index'));
const SearchPlayground = lazy(() => import('./search-playground'));
const SearchAssistant = lazy(() => import('./search-assistant'));
const SearchAssistantLogs = lazy(() => import('./search-assistant-logs'));
const OnboardingChat = lazy(() => import('./onboarding-chat'));
const InterviewQuestion = lazy(() => import('./interview-question'));
const InterviewSession = lazy(() => import('./interview-session'));
const InterviewFlows = lazy(() => import('./interview-flow'));
const ProviderWallet = lazy(() => import('./provider-wallet'));
const ProviderPayout = lazy(() => import('./provider-payout'));
const LedgerManagement = lazy(() => import('./ledger'));
const PaymentIn = lazy(() => import('./payment-in'));
const PlatformAccount = lazy(() => import('./platform-account'));
const LionRoseMenu = lazy(() => import('./lionrose'));
const OrganizationInvitations = lazy(() => import('./organization-invitations'));
const SeoLocations = lazy(() => import('./seo/locations'));
const SeoServices = lazy(() => import('./seo/services'));
const SeoAdditionalNeeds = lazy(() => import('./seo/additional-needs'));
const SeoTranslations = lazy(() => import('./seo/translations'));
const SeoGateway = lazy(() => import('./seo/gateway'));
const PartnerRecruitmentPage = lazy(() => import('./partner-recruitment-page'));
const UserRelationships = lazy(() => import('./user-relationships'));
const LandingPageSearch = lazy(() => import('./landing-page-search'));
const HrUsers = lazy(() => import('./hr-users'));
const SaleUsers = lazy(() => import('./sale-users'));
const SaleProfileUsers = lazy(() => import('./sale-profile-users'));
const TestimonialsPage = lazy(() => import('./testimonials'));
const SeoSupport = lazy(() => import('./seo-support'));
const WellnessTest = lazy(() => import('./wellness-test'));
const VirtualViews = lazy(() => import('./virtual-views'));
const VirtualViewsList = lazy(() => import('./virtual-views/list'));
const QuickQuest = lazy(() => import('./quick-quest'));
const BrevoContact = lazy(() => import('./brevo-contact'));
const OutreachModule = lazy(() => import('./outreach/OutreachModule'));
const GoogleAdsCampaigns = lazy(() => import('./google-ads/campaigns'));
const GoogleAdsCostReport = lazy(() => import('./google-ads/cost'));
const GoogleAdsDailyReport = lazy(() => import('./google-ads/daily'));
const GoogleAdsInstallReport = lazy(() => import('./google-ads/install'));
const AppsflyerMediaSource = lazy(() => import('./google-ads/appsflyer-media-source'));
const AppsflyerReport = lazy(() => import('./google-ads/appsflyer-report'));
const PosthogEventUsersApp = lazy(() => import('./traffic-website/posthog-event-users-app'));
const PosthogUsersWebsite = lazy(() => import('./traffic-website/posthog-users-website'));
const TrafficCountryWebsite = lazy(() => import('./traffic-website/traffic-country-website'));
const AnalyticsReport = lazy(() => import('./analytics-report'));
const FinanceCostLinks = lazy(() => import('./finance-cost-links'));
const AdImageGenerator = lazy(() => import('./ad-image-generator'));

export const routes = [
  {
    path: 'home',
    component: Home,
    permission: null,
  },
  {
    path: 'ad-image-generator',
    component: AdImageGenerator,
    permission: null,
  },
  {
    path: 'chat-bot',
    component: ChatBot,
    permission: null,
  },
  {
    path: 'organization-invitations',
    component: OrganizationInvitations,
    permission: null,
  },
  {
    path: 'ldp-inquiries',
    component: LdpInquiries,
    permission: null,
  },
  {
    path: 'ldp-inquiry-send-emails',
    component: LdpInquirySendEmails,
    permission: null,
  },
  {
    path: 'reports',
    component: Reports,
    permission: null,
  },
  {
    path: 'profile',
    component: Profile,
    permission: null,
  },

  {
    path: 'orders',
    component: Orders,
    permission: null,
  },
  {
    path: 'orders/booking',
    component: BookingStatistics,
    permission: null,
  },
  {
    path: 'orders/booking',
    component: BookingStatistics,
    permission: null,
  },
  {
    path: 'orders/product',
    component: ProductOrders,
    permission: null,
  },
  {
    path: 'countries',
    component: Countries,
    permission: null,
  },
  {
    path: 'appointment-requests',
    component: AppointmentRequests,
    permission: null,
  },
  {
    path: 'longevity-consults',
    component: LongevityConsults,
    permission: null,
  },
  {
    path: 'services',
    component: Services,
    permission: null,
  },
  {
    path: 'service-sessions',
    component: ServiceSessions,
    permission: null,
  },
  {
    path: 'seller-about-score',
    component: SellerAboutScore,
    permission: null,
  },
  {
    path: 'provider-verification',
    component: ProviderVerification,
    permission: null,
  },
  {
    path: 'instructors',
    component: Instructors,
    permission: null,
  },
  {
    path: 'services/create-logs',
    component: ServiceCreateLogs,
    permission: null,
  },
  {
    path: 'clinics',
    component: Clinics,
    permission: null,
  },
  {
    path: 'amenities',
    component: Amenities,
    permission: null,
  },
  {
    path: 'reports/cabins-performance',
    component: CabinsOrder,
    permission: null,
  },
  {
    path: 'reports/revenue',
    component: Sale,
    permission: null,
  },
  {
    path: 'reports/dept',
    component: Dept,
    permission: null,
  },

  {
    path: 'users',
    component: Users,
    permission: null,
  },
  {
    path: 'users/:id',
    component: UserDetailPage,
    permission: null,
  },
  {
    path: 'admin-2fa',
    component: Admin2FA,
    permission: null,
  },
  {
    path: 'categories',
    component: Categories,
    permission: null,
  },
  {
    path: 'reviews',
    component: Reviews,
    permission: null,
  },
  {
    path: 'rates',
    component: Rates,
    permission: null,
  },
  {
    path: 'currencies',
    component: Currencies,
    permission: null,
  },
  {
    path: 'languages',
    component: Languages,
    permission: null,
  },
  {
    path: 'posts',
    component: Posts,
    permission: null,
  },
  {
    path: 'sites',
    component: Sites,
    permission: null,
  },

  {
    path: 'widgets',
    component: Widgets,
    permission: null,
  },
  {
    path: 'faq',
    component: Faq,
    permission: null,
  },
  {
    path: 'cabin-rates',
    component: CabinRates,
    permission: null,
  },
  {
    path: 'permissions',
    component: Roles,
    permission: null,
  },
  {
    path: 'orders/details/:id',
    component: OrderDetails,
    permission: null,
  },

  {
    path: 'invoice',
    component: Invoice,
    permission: null,
  },
  {
    path: 'templates',
    component: Templates,
    permission: null,
  },
  {
    path: 'programs',
    component: Programs,
    permission: null,
  },
  {
    path: 'roles',
    component: Roles,
    permission: null,
  },
  {
    path: 'app-all',
    component: App,
    permission: null,
  },
  {
    path: 'landing-page',
    component: LandingPage,
    permission: null,
  },
  {
    path: 'seller',
    component: SellerPage,
    permission: null,
  },
  {
    path: 'seller/:id',
    component: SellerDetailPage,
    permission: null,
  },
  {
    path: 'seller/:id/profile',
    component: SellerContentPage,
    permission: null,
  },
  {
    path: 'organization',
    component: OrganizationPage,
    permission: null,
  },
  {
    path: 'affcampaign',
    component: Affcampaign,
    permission: null,
  },
  {
    path: 'pro-referral',
    component: ProReferral,
    permission: null,
  },
  {
    path: 'campaign-user',
    component: CampaignUser,
    permission: null,
  },
  {
    path: 'conversion',
    component: Conversion,
    permission: null,
  },
  {
    path: 'click',
    component: Click,
    permission: null,
  },
  {
    path: 'chat',
    component: Chat,
    permission: null,
  },
  {
    path: 'audit-logs-chat',
    component: AuditLogsChat,
    permission: null,
  },
  {
    path: 'direct-messages',
    component: DirectMessages,
    permission: null,
  },
  {
    path: 'direct-messages/:id',
    component: DirectMessages,
    permission: null,
  },
  {
    path: 'notifications',
    component: Notifications,
    permission: null,
  },
  {
    path: 'products',
    component: Products,
    permission: null,
  },
  {
    path: 'professions',
    component: Professions,
    permission: null,
  },
  {
    path: 'experts',
    component: Experts,
    permission: null,
  },
  {
    path: 'interests',
    component: Interests,
    permission: null,
  },
  {
    path: 'requests',
    component: Requests,
    permission: null,
  },
  {
    path: 'requests-pending-approval',
    component: RequestsPendingApproval,
    permission: null,
  },
  {
    path: 'public-offers',
    component: PublicOffers,
    permission: null,
  },
  {
    path: 'reviews',
    component: Reviews,
    permission: null,
  },
  {
    path: 'subscribers',
    component: Subscribers,
    permission: null,
  },
  {
    path: 'subscriptions',
    component: Subscriptions,
    permission: null,
  },
  {
    path: 'subscription-plans',
    component: SubscriptionPlans,
    permission: null,
  },
  {
    path: 'offers',
    component: Offers,
    permission: null,
  },
  {
    path: 'brand',
    component: Brands,
    permission: null,
  },
  {
    path: 'user-revenue',
    component: UserRevenue,
    permission: null,
  },
  {
    path: 'withdrawal',
    component: Withdrawals,
    permission: null,
  },
  {
    path: 'system-log',
    component: SystemLog,
    permission: null,
  },
  {
    path: 'event-log',
    component: EventLog,
    permission: null,
  },
  {
    path: 'app-settings',
    component: AppSettings,
    permission: null,
  },
  {
    path: 'cold-start-settings',
    component: ColdStartSettings,
    permission: null,
  },
  {
    path: 'cold-start-activity',
    component: ColdStartActivity,
    permission: null,
  },
  {
    path: 'credit-overview',
    component: CreditOverview,
    permission: null,
  },
  {
    path: 'credit-config',
    component: CreditConfig,
    permission: null,
  },
  {
    path: 'credit-packages',
    component: CreditPackages,
    permission: null,
  },
  {
    path: 'credit-adjust',
    component: CreditAdjust,
    permission: null,
  },
  {
    path: 'tracking-pages',
    component: TrackingPages,
    permission: null,
  },
  {
    path: 'whatsapp-messages',
    component: WhatsAppMessages,
    permission: null,
  },
  // Credit Lookup merged into Credit Transactions (filter by user shows balances)
  // {
  //   path: 'credit-wallet',
  //   component: CreditWallet,
  //   permission: null,
  // },
  {
    path: 'credit-transactions',
    component: CreditTransactions,
    permission: null,
  },
  {
    path: 'credit-purchases',
    component: CreditPurchases,
    permission: null,
  },
  {
    path: 'voice-downloads',
    component: VoiceDownloads,
    permission: null,
  },
  {
    path: 'creator-earnings',
    component: CreatorEarnings,
    permission: null,
  },
  {
    path: 'creator-payouts',
    component: CreatorPayouts,
    permission: null,
  },
  {
    path: 'file-manager',
    component: FileManager,
    permission: null,
  },
  {
    path: 'notification-channels',
    component: NotificationChannels,
    permission: null,
  },
  {
    path: 'notification-all',
    component: NotificationAll,
    permission: null,
  },
  {
    path: 'menu-manager',
    component: MenuManager,
    permission: null,
  },
  {
    path: 'role-menu',
    component: RoleMenu,
    permission: null,
  },
  {
    path: 'user-menu',
    component: UserMenu,
    permission: null,
  },
  {
    path: 'notification-config',
    component: NotificationConfig,
    permission: null,
  },
  {
    path: 'wallets',
    component: Wallets,
    permission: null,
  },
  {
    path: 'service-sample',
    component: ServiceSamples,
    permission: null,
  },
  {
    path: 'health-solution',
    component: HealthSolutions,
    permission: null,
  },
  {
    path: 'library-category',
    component: LibraryCategories,
    permission: null,
  },
  {
    path: 'health-check',
    component: HealthCheck,
    permission: null,
  },
  {
    path: 'voice-posts',
    component: VoicePosts,
    permission: null,
  },
  {
    path: 'voice-boost',
    component: VoiceBoost,
    permission: null,
  },
  {
    path: 'voice-trending',
    component: VoiceTrending,
    permission: null,
  },
  // {
  //   path: 'voice-home-widgets',
  //   component: VoiceHomeWidgets,
  //   permission: null,
  // },
  {
    path: 'voice-hashtags',
    component: VoiceHashtags,
    permission: null,
  },
  {
    path: 'voice-posts-analytics',
    component: VoicePostsAnalytics,
    permission: null,
  },
  {
    path: 'voice-view-report',
    component: VoiceViewReport,
    permission: null,
  },
  {
    path: 'voice-duration-report',
    component: VoiceDurationReport,
    permission: null,
  },
  {
    path: 'voice-view-log',
    component: VoiceViewLog,
    permission: null,
  },
  {
    path: 'feed-simulator',
    component: FeedSimulator,
    permission: null,
  },
  {
    path: 'voice-posts-no-speech',
    component: VoicePostsNoSpeech,
    permission: null,
  },
  {
    path: 'user-follows',
    component: UserFollows,
    permission: null,
  },
  {
    path: 'fake-comment-templates',
    component: FakeCommentTemplates,
    permission: null,
  },
  {
    path: 'vouchers',
    component: Vouchers,
    permission: null,
  },
  {
    path: 'finance-home',
    component: FinanceDashboard,
    permission: null,
  },
  {
    path: 'affiliate-tier',
    component: AffiliateTier,
    permission: null,
  },
  {
    path: 'affiliate-tier-history',
    component: AffiliateTierHistory,
    permission: null,
  },
  {
    path: 'affiliate-tier-users',
    component: AffiliateTierUsers,
    permission: null,
  },
  {
    path: 'organization-application',
    component: OrganizationApplication,
    permission: null,
  },
  {
    path: 'seed-buyer',
    component: SeedBuyer,
    permission: null,
  },
  {
    path: 'request-seed',
    component: RequestSeed,
    permission: null,
  },
  {
    path: 'service-refine',
    component: ServiceRefine,
    permission: null,
  },
  // Tạm ẩn Search v2 cùng menu (SHOW_SEARCH_V2 trong src/menu).
  ...(SHOW_SEARCH_V2
    ? [
        {
          path: 'search-index',
          component: SearchIndex,
          permission: null,
        },
        {
          path: 'search-playground',
          component: SearchPlayground,
          permission: null,
        },
        {
          path: 'search-assistant',
          component: SearchAssistant,
          permission: null,
        },
        {
          path: 'search-assistant-logs',
          component: SearchAssistantLogs,
          permission: null,
        },
      ]
    : []),
  {
    path: 'request-image',
    component: RequestImage,
    permission: null,
  },
  {
    path: 'onboarding-chat',
    component: OnboardingChat,
    permission: null,
  },
  {
    path: 'interview-question',
    component: InterviewQuestion,
    permission: null,
  },
  {
    path: 'interview-session',
    component: InterviewSession,
    permission: null,
  },
  {
    path: 'interview-flow',
    component: InterviewFlows,
    permission: null,
  },
  {
    path: 'provider-wallet',
    component: ProviderWallet,
    permission: null,
  },
  {
    path: 'provider-payout',
    component: ProviderPayout,
    permission: null,
  },
  {
    path: 'ledger',
    component: LedgerManagement,
    permission: null,
  },
  {
    path: 'payment-in',
    component: PaymentIn,
    permission: null,
  },
  {
    path: 'platform-account',
    component: PlatformAccount,
    permission: null,
  },
  {
    path: 'lionrose',
    component: LionRoseMenu,
    permission: null,
  },
  {
    path: 'seo/locations',
    component: SeoLocations,
    permission: null,
  },
  {
    path: 'seo/services',
    component: SeoServices,
    permission: null,
  },
  {
    path: 'seo/additional-needs',
    component: SeoAdditionalNeeds,
    permission: null,
  },
  {
    path: 'seo/translations',
    component: SeoTranslations,
    permission: null,
  },
  {
    path: 'seo/gateway',
    component: SeoGateway,
    permission: null,
  },
  {
    path: 'partner-recruitment-page',
    component: PartnerRecruitmentPage,
    permission: null,
  },
  {
    path: 'user-relationships',
    component: UserRelationships,
    permission: null,
  },
  {
    path: 'landing-page-search',
    component: LandingPageSearch,
    permission: null,
  },
  {
    path: 'hr-users',
    component: HrUsers,
    permission: null,
  },
  {
    path: 'sale-users',
    component: SaleUsers,
    permission: null,
  },
  {
    path: 'sale-profile-users',
    component: SaleProfileUsers,
    permission: null,
  },
  {
    path: 'testimonials',
    component: TestimonialsPage,
    permission: null,
  },
  {
    path: 'seo-support',
    component: SeoSupport,
    permission: null,
  },
  {
    path: 'wellness-test',
    component: WellnessTest,
    permission: null,
  },
  {
    path: 'virtual-views/add',
    component: VirtualViews,
    permission: null,
  },
  {
    path: 'virtual-views/list',
    component: VirtualViewsList,
    permission: null,
  },
  {
    path: 'quick-quest/templates',
    component: QuickQuest,
    permission: null,
  },
  {
    path: 'brevo-contact',
    component: BrevoContact,
    permission: null,
  },
  {
    path: 'outreach',
    component: OutreachModule,
    exact: false,
    permission: null,
  },
  {
    path: 'google-ads/campaigns',
    component: GoogleAdsCampaigns,
    permission: null,
  },
  {
    path: 'google-ads/cost',
    component: GoogleAdsCostReport,
    permission: null,
  },
  {
    path: 'google-ads/daily',
    component: GoogleAdsDailyReport,
    permission: null,
  },
  {
    path: 'google-ads/install',
    component: GoogleAdsInstallReport,
    permission: null,
  },
  {
    path: 'google-ads/appsflyer-media-source',
    component: AppsflyerMediaSource,
    permission: null,
  },
  {
    path: 'google-ads/appsflyer-report',
    component: AppsflyerReport,
    permission: null,
  },
  {
    path: 'traffic-website/posthog-event-users-app',
    component: PosthogEventUsersApp,
    permission: null,
  },
  {
    path: 'traffic-website/posthog-users-website',
    component: PosthogUsersWebsite,
    permission: null,
  },
  {
    path: 'traffic-website/traffic-country-website',
    component: TrafficCountryWebsite,
    permission: null,
  },
  {
    path: 'analytics-report',
    component: AnalyticsReport,
    permission: null,
  },
  {
    path: 'finance-cost-links',
    component: FinanceCostLinks,
    permission: null,
  },
];
